import { Avatar, Box, Flex, Paper, Text } from '@mantine/core';

import { useAppSelector } from '@/store/hooks';
import FallbackText from '@/components/FallbackText';

import styles from './ApplicationSettingsPage.module.scss';
import FeatureFlagPage from './FeatureFlags';

const ApplicationSettingsPage = () => {
  const { user } = useAppSelector((state) => state.auth);
  const name = `${user?.given ?? ''} ${user?.family ?? ''}`.trim();

  return (
    <div className={styles.layout}>
      <Box pb="40px">
        <Text className={styles.title}>Manage Your Settings&nbsp;</Text>
      </Box>
      <Flex gap={{ base: 5, xs: 'md', md: 'xl', xl: 50 }}>
        <Box h={'160px'} w={'400px'}>
          <Paper p="lg" withBorder>
            <Avatar
              color="initials"
              allowedInitialsColors={['plum']}
              name={name}
              variant="filled"
              radius="xl"
              size="lg"
              styles={{
                placeholder: {
                  fontSize: '1rem',
                  fontWeight: 700
                }
              }}
            />
            <FallbackText size="2xl" c={'neutral.8'} fw={700} mb={'sm'} mt={'xs'}>
              {user?.given} {user?.family}
            </FallbackText>
          </Paper>
        </Box>
        <FeatureFlagPage />
      </Flex>
    </div>
  );
};

export default ApplicationSettingsPage;
